import { Platform } from 'src/models/platform/_types';
import { updatePlatform } from 'src/models/platform/platform';
import { Session } from 'src/models/session/_types';

import type { QueryClient } from '@tanstack/react-query';

/** tagType values on FormTagsSelect that store options on the platform (not the tags API) */
export type PlatformManagedListTagType =
  | 'client'
  | 'exercise'
  | 'groupAssessment'
  | 'groupResource'
  | 'package'
  | 'product'
  | 'service'
  | 'video';

/**
 * Persists a new custom tag name on the platform and refreshes session so
 * other screens see it immediately. Callers must not invalidate session
 * before this finishes — that race caused new resource tags to disappear
 * until a full page reload.
 */
export async function persistNewPlatformTagListEntry(
  session: Session,
  tagType: PlatformManagedListTagType,
  newTagName: string,
  queryClient: QueryClient
): Promise<void> {
  if (!session.id) {
    return;
  }

  const listKey = `${tagType}Tags` as keyof Session;
  const tagsList = (session[listKey] as string[] | undefined) || [];

  if (tagsList.includes(newTagName)) {
    return;
  }

  await updatePlatform(session.id, {
    [listKey]: [...tagsList, newTagName],
  } as Partial<Platform>);

  await queryClient.invalidateQueries({ queryKey: ['session'] });
}
